import React from 'react';

/** Affiche « Prénom N. » à partir du nom complet. */
export const formatPersonShortName = (fullName) => {
  const parts = String(fullName || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '—';
  if (parts.length === 1) return parts[0];
  const first = parts[0];
  const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
  return `${first} ${lastInitial}.`;
};

const pillBaseStyle = {
  fontSize: '0.9rem',
  fontWeight: 600,
  padding: '0.45rem 0.85rem',
  borderWidth: 1.5,
};

const pillIdleStyle = {
  ...pillBaseStyle,
  backgroundColor: 'rgba(51, 65, 85, 0.06)',
  borderColor: 'rgba(51, 65, 85, 0.45)',
  color: '#334155',
};

/**
 * Étiquettes cliquables de personnes (même UI que les destinataires des crons).
 *
 * @param {{
 *   items: Array<{ id: string|number, label: string, email?: string|null, tooltip?: string }>,
 *   selectedIds: Array<string|number>,
 *   onToggle: (id: number) => void,
 *   emptyLabel?: string,
 *   disabled?: boolean,
 * }} props
 */
const PersonPills = ({
  items,
  selectedIds,
  onToggle,
  emptyLabel = 'Aucun élément.',
  disabled = false,
}) => {
  if (!items || items.length === 0) {
    return <span className="text-sm text-secondary-light">{emptyLabel}</span>;
  }

  const selected = (selectedIds || []).map(Number);

  return (
    <div className="d-flex flex-wrap gap-2">
      {items.map((item) => {
        const id = Number(item.id);
        const checked = selected.includes(id);
        const label = formatPersonShortName(item.label);
        const noEmail = !item.email;
        return (
          <button
            key={item.id}
            type="button"
            className={`btn ${checked ? 'btn-primary-600 text-white' : 'btn-outline-primary'}`}
            style={checked
              ? pillBaseStyle
              : {
                ...pillIdleStyle,
                ...(noEmail ? {
                  opacity: 0.7,
                  borderColor: 'rgba(217, 119, 6, 0.55)',
                  color: '#b45309',
                  backgroundColor: 'rgba(251, 191, 36, 0.12)',
                } : {}),
              }}
            title={item.email || item.tooltip || (noEmail ? 'Pas d’email' : '')}
            aria-pressed={checked}
            disabled={disabled || noEmail}
            onClick={() => onToggle(id)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default PersonPills;
